<template>
    <div class="home">
      <h1>Welcome to the Booking System</h1>
      <p>Book your appointment easily with our system.</p>
  
      <div class="buttons">
        <router-link to="/booking">
          <button>Book an Appointment</button>
        </router-link>
        
        <router-link to="/bookings" v-if="user">
          <button>My Bookings</button>
        </router-link>
  
        <router-link to="/admin" v-if="user">
          <button>Admin Panel</button>
        </router-link>
  
        <router-link to="/login" v-if="!user">
          <button>Login</button>
        </router-link>

        <router-link to="/view-booking">
          <button>View My Booking</button>
        </router-link>
  
        <button v-if="user" @click="logout">Logout</button>
      </div>
    </div>
  </template>
  
  <script>
  import { auth } from "../firebase/firebaseConfig";
  import { onAuthStateChanged, signOut } from "firebase/auth";
  
  export default {
    data() {
      return { user: null };
    },
    created() {
      onAuthStateChanged(auth, (user) => {
        this.user = user;
      });
    },
    methods: {
      async logout() {
        await signOut(auth);
        alert("✅ Logged out successfully!");
        this.$router.push("/login");
      },
    },
  };
  </script>
  
  <style scoped>
  .home {
    text-align: center;
    padding: 40px;
  }
  h1 {
    color: #333;
  }
  p {
    font-size: 18px;
  }
  .buttons {
    margin-top: 20px;
  }
  button {
    margin: 10px;
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 5px;
  }
  button:hover {
    background-color: #0056b3;
  }
  </style>
  